import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import Categories from '../components/Categories';

const CategoriesBridge = react2angular(Categories);
export default CategoriesBridge;
